import request from '../request';

function findAll(year,id) {
  return request({
    url: `/orderBy/findAll`,
    params:{year:year,id:id},
    method: 'get',
  });
}

function findAllExcel(year,id) {
  return request({
    url: `/orderBy/findAllExcel`,
    params:{year:year,id:id},
    method: 'get',
  });
}

export default {
  findAll,
  findAllExcel
};